import React from 'react';
import { Link } from '@this/src/components/shared/ui/navigations/link';
import { useAITTheme } from '@this/shared/ui/theme';

type TripIdDisplayProps = {
  tripId: number;
  variant?: 'header' | 'footer';
};

const TripIdWithArrangementLink: React.FC<TripIdDisplayProps> = ({ tripId, variant = 'footer' }) => {
  const { theme } = useAITTheme();
  const isHeader = variant === 'header';
  const fontSize = '0.875rem';

  return (
    <span style={{ fontSize, color: isHeader ? '#fff' : undefined }}>
      <span style={{ color: isHeader ? undefined : theme.grayTextColor, marginRight: '4px' }}>旅程番号:</span>
      <span>{tripId}</span>
      <span style={{ marginLeft: '4px' }}>
        （
        <Link
          href={`/arrangement/virtual_counter?trip_id=${tripId}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize, ...(isHeader ? { color: '#fff' } : {}) }}
        >
          手配画面
        </Link>
        ）
      </span>
    </span>
  );
};

export default TripIdWithArrangementLink;
